export default (type?: string) => [
  { label: 'Transação', value: 'protocol_number' },
  { label: 'Tipo', value: 'eventable_type' },
  { label: 'Detalhes', value: 'details' },
  { label: 'Placa do Veículo', value: 'license_plate' },
  { label: 'Vlr. Total', value: 'total_amount' },
  { label: 'Tarifas', value: 'fee_total_amount' },
  { label: 'Ret. IR', value: 'income_tax_total' },
  { label: 'Filial', value: 'branch', hidden: type === 'establishment_bills' },
  { label: 'Cartão', value: 'card' },
  { label: 'Un/Consumo Informado', value: 'usage_declaration' },
  { label: 'Data e Hora', value: 'created_at' },
  { label: 'Ações', value: 'actions', className: 'w-0' },
]
